export enum TenantTypeModel
{
  Corporate = 0,
  Individual = 1,
  BrokerPool = 2
}